const palette = {
  common: {
    black: '#000',
    white: '#fff',
  },
  primary: {
    light: '#d55b5b',
    main: '#b51e1f',
    dark: '#920506',
  },
  secondary: {
    light: '#dee1e5',
    main: '#8d8d92',
    dark: '#000',
  },
  error: {
    light: '#d55b5b',
    main: '#b51e1f',
    dark: '#920506',
  },
  success: {
    main: '#14d07f',
  },
  warning: {
    main: '#ff9b0f',
  },
  text: {
    primary: '#000',
    secondary: '#8d8d92',
    dark: '#121926',
    hint: '#eef2f6',
  },
  orange: {
    '50': '#fffdfa',
    '100': '#fef9ed',
    '400': '#fff3d4',
    '600': '#ff9b0f',
  },
  violet: {
    '50': '#f9f6ff',
    '100': '#eae1ff',
    '400': '#d5c3fe',
    '600': '#976cfb',
  },
  grey: {
    '100': '#f5f7f9',
    '150': '#e9eef3',
    '200': '#dee1e5',
    '600': '#c0c1c8',
    '700': '#aaaab0',
    '800': '#8d8d92',
  },
  blue: {
    100: '#ecf6ff',
    600: '#249bfc',
    700: '#1200ff',
    900: '#412a79',
  },
  red: {
    '100': '#f9ecec',
    '400': '#d55b5b',
    '600': '#b51e1f',
    '800': '#920506',
  },
  green: {
    '50': '#f8fdfb',
    '100': '#e7f8f3',
    '400': '#c8f1e4',
    '600': '#14d07f',
  },
  yellow: {
    '100': '#fff9ef',
    '150': '#ffeeaa',
    '200': '#fde9c8',
    '300': '#ffd47e',
    '400': '#f4a201',
  },
  pink: {
    50: '#fff7fe',
    100: '#ffeffd',
    400: '#ffe2fc',
    600: '#fe8cc5',
  },
  inputs: {
    defaultPrimary: '#a0a8c4',
    defaultSecondary: '#33384d',
    hoverPrimary: '#6396F0',
    hoverSecondary: '#0A3177',
    disabled: '#d3dee8',
    disabledText: '#5d647a',
    reactionFocused: '#d0e1ff',
    yellow: '#ffeeaa',
    yellowFocused: '#ffcb72',
    yellowFocusedBorderPrimary: '#e89802',
    yellowFocusedBorderSecondary: '#b65f0e',
  },
};

export default palette;
